import {
  GAD_SOURCE,
  GCLID,
  REGION,
  REGION_ID,
  SRSLTID,
  STORE,
  STORE_CODE,
} from '../constants/queries';

export default function clearRegion(options?: { pathname?: string }) {
  const url = options?.pathname
    ? new URL(options.pathname, globalThis.window.location.origin)
    : new URL(globalThis.window.location.href);

  url.searchParams.delete(REGION);
  url.searchParams.delete(REGION_ID);
  url.searchParams.delete(STORE_CODE);
  url.searchParams.delete(STORE);
  url.searchParams.delete(GAD_SOURCE);
  url.searchParams.delete(GCLID);
  url.searchParams.delete(SRSLTID);

  globalThis.window.location.replace(url.href);
}
